import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <main className="bg-[#F4F1EB] text-[#2C2A29] font-sans min-h-screen" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-16 sm:py-24">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-sm text-[#692128] hover:text-[#8B2635] mb-10 tracking-wide font-medium transition-colors"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <img
            src="/assets/logo.png"
            alt="Guardian Grace Foundation"
            className="h-12 w-12 object-contain rounded-full ring-1 ring-[#E2DCD0] bg-[#FAF8F5]"
          />
          <div className="leading-tight">
            <div className="font-serif text-xl text-[#692128] font-semibold">
              Guardian Grace
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#5C5856]">
              Family &amp; Community Foundation
            </div>
          </div>
        </div>

        <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-3">
          {title}
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight mb-4">
          {title}
        </h1>
        <p className="text-sm text-[#5C5856] mb-12">Last updated: {lastUpdated}</p>

        <div className="prose-legal text-[#2C2A29] leading-relaxed space-y-6">
          {children}
        </div>

        <div className="mt-20 pt-8 border-t border-[#E2DCD0] text-xs tracking-[0.22em] uppercase text-[#8B2635] font-semibold text-center">
          Compassion · Service · Family · Community · Legacy · Faith
        </div>
      </div>
    </main>
  );
}
